export const AUTH_KEY = 'spartacus⚿⚿auth';
export const USER_ID = 'userId';
export const CURR = 'current';
export const REDIRECT_KEY = 'redirectAfterLogin';

export function captureRedirectIfProtected() {
  const currentUrl = window.location.pathname + window.location.search;
  const isPublicUrl = isPublicOrUnprotectedUrl(currentUrl);

  if (isPublicUrl) return;
  const authToken = localStorage.getItem(AUTH_KEY);
  const isLoggedIn = authToken?.includes(`"${USER_ID}":"${CURR}"`);

  if (!isLoggedIn && !isPublicUrl) {
    localStorage.setItem(REDIRECT_KEY, currentUrl);
  }
}

export function isPublicOrUnprotectedUrl(url: string): boolean {
  const result =
    url.length < 10 ||
    url === '/' ||
    /\/[a-z]{2,3}\/[A-Z]{3}\/(homepage|login|register|contact-us|customer-register)$/i.test(url);
  return result;
}

export function preMarkPunchOut() {
  const url = new URL(window.location.href);
  const isPunchOutUrl = url.pathname.includes('/punchout/cxml/session');
  const sid = url.searchParams.get('sid');

  if (isPunchOutUrl && sid) {
    localStorage.setItem('punchout-sid-key', sid);
    sessionStorage.setItem('isPunchOut', 'true');
  }
}

export function detectPunchOut() {
  const isThisTabPunchOut = sessionStorage.getItem('isPunchOut') === 'true';
  const punchOutKey = localStorage.getItem('punchout-sid-key');
  const punchOutUrl = window.location.pathname.includes('/punchout/cxml/session');

  // Case: Not punchout tab but punchout session exists → clear and redirect
  if (punchOutKey && !isThisTabPunchOut && !punchOutUrl) {
    localStorage.clear();
    sessionStorage.clear();
    redirectToHomepage();
    return;
  }
}

export function redirectToHomepage() {
  const match = window.location.pathname.match(/^\/[^/]+\/[^/]+\/[^/]+/);
  const base = match?.[0] || '';
  window.location.href = `${base}/homepage`;
}


